export const NON_MOBILE_WIDTH = 768;
export const NON_MOBILE_HEIGHT = 480;
export const LAPTOP_WIDTH = 1024;
export const LAPTOP_HEIGHT = 550;
export const PROJECTS_PER_BATCH = 9;
